import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../lib/cn.js';
import { Spinner } from './Spinner.js';
const base = cn('inline-flex items-center justify-center gap-2 whitespace-nowrap', 'font-medium rounded-[var(--radius-sm)]', 'transition-[background-color,border-color,box-shadow,transform,color]', 'duration-[var(--motion-fast)] ease-[var(--ease-standard)]', 'active:translate-y-[0.5px] disabled:opacity-55 disabled:cursor-not-allowed', 'disabled:active:translate-y-0 select-none');
/*
 * Hover DARAJA bilan beriladi, `brightness()` bilan emas.
 *
 * `brightness-110` quyuq navyni kulrangga emas, oqargan ko'kka aylantiradi va
 * SQB shkalasidagi keyingi pog'ona bilan mos tushmasdi. Endi har holat o'z
 * tokenini oladi: hover `--primary-300`, bosilgani `--primary-700`.
 */
const variantClass = {
    primary: cn('bg-primary text-primary-contrast shadow-[var(--shadow-1)]', 'hover:bg-primary-300 active:bg-primary-700'),
    accent: cn('bg-accent text-accent-contrast shadow-[var(--shadow-1)]', 'hover:brightness-110 active:brightness-95'),
    secondary: cn('bg-surface text-primary border border-border', 'hover:bg-accent-soft hover:border-accent/30'),
    /* `ghost` ham TUGMA bo'lib ko'rinishi kerak: shaffof chegara joyni
       oldindan egallaydi va hover da chegara paydo bo'lganda yozuv
       qimirlamaydi. Ilgari chegara umuman yo'q edi va "Yangilash" havolaga
       o'xshab qolgandi — odam uni bosish mumkinligini bilmasdi. */
    ghost: cn('border border-transparent text-primary', 'hover:border-border hover:bg-surface-2'),
    danger: cn('bg-danger text-danger-contrast shadow-[var(--shadow-1)]', 'hover:brightness-110 active:brightness-95'),
};
const sizeClass = {
    sm: 'h-[var(--size-control-sm)] px-4 text-sm',
    md: 'h-10 px-5 text-sm',
    lg: 'h-[var(--size-control)] px-6 text-base',
};
const spinnerSize = { sm: 'sm', md: 'sm', lg: 'md' };
/**
 * Tugma KO'RINISHINING sinflari — havola uchun.
 *
 * Ba'zan harakat aslida HAVOLA bo'ladi (yangi oynada ochiladigan tashqi
 * manzil) va u tugmadek ko'rinishi kerak. Bunday joyda `<button onClick=…>`
 * yozish noto'g'ri bo'lardi: havola o'rta tugma bilan ochilishi, nusxa
 * olinishi va klaviatura bilan boshqacha ishlashi kerak.
 *
 * `asChild` naqshi ATAYLAB olinmadi — u bitta `Slot` komponentini va
 * `children` ni klonlash mantig'ini olib kelardi; bu yerda esa kerak
 * bo'lgani faqat sinflar ro'yxati.
 */
export const buttonClass = (options = {}) => cn(base, variantClass[options.variant ?? 'primary'], sizeClass[options.size ?? 'md'], options.className);
/**
 * Asosiy harakat tugmasi. `loading` holatida bosilmaydi — skaner yoki
 * sabrsiz barmoq bir so'rovni ikki marta yubormasligi uchun.
 */
export const Button = ({ variant = 'primary', size = 'md', loading = false, type = 'button', disabled, className, children, ...rest }) => (_jsxs("button", { type: type, disabled: disabled === true || loading, "aria-busy": loading || undefined, className: cn(base, variantClass[variant], sizeClass[size], className), ...rest, children: [loading ? _jsx(Spinner, { size: spinnerSize[size] }) : null, children] }));
//# sourceMappingURL=Button.js.map